import React from 'react';

// The app's on/off switch, styled to match the activity log's toggle. It is a real button with a
// switch role, so it works from the keyboard and announces on/off to a screen reader.
// A visible label needs both `labelledBy` (its id, which names the switch) and a <label htmlFor> on
// it pointing at `id` (which makes the text clickable); a button is not reliably named by <label>
// alone. Pass `label` instead when there is no visible label.

const ToggleSwitch = ({ id, checked, onChange, disabled = false, label, labelledBy, describedBy, className = '' }) => {
  const track = checked ? 'bg-jims-cyan' : 'bg-gray-300';
  const hover = disabled ? '' : checked ? 'hover:bg-jims-cyan-dark' : 'hover:bg-gray-400';

  return (
    <button
      id={id}
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={labelledBy ? undefined : label}
      aria-labelledby={labelledBy}
      aria-describedby={describedBy}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`relative inline-flex h-6 w-11 flex-shrink-0 items-center rounded-full touch-manipulation
        transition-colors motion-reduce:transition-none
        focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-jims-cyan
        disabled:opacity-50 disabled:cursor-not-allowed ${track} ${hover} ${className}`}
    >
      <span
        className={`inline-block h-4 w-4 transform rounded-full bg-white shadow
          transition-transform motion-reduce:transition-none
          ${checked ? 'translate-x-6' : 'translate-x-1'}`}
      />
    </button>
  );
};

export default ToggleSwitch;
